export const SET_LOADING = `payments/set_loading`;
export const SET_PAYMENTS = `payments/set_payments`;



// WEBPACK FOOTER //
// ./src/store/payments/types.js